import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../theme/ThemeContext';

// Two-position pill toggle: sun (light) / moon (dark). Sliding indicator glides
// between the two states with a spring animation.
export default function ThemeToggle({ className = '' }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
      aria-pressed={isDark}
      data-testid="theme-toggle"
      className={`relative inline-flex items-center h-9 w-[70px] shrink-0 rounded-full border hairline-strong overflow-hidden ${className}`}
      style={{ background: 'var(--glass-bg-light)' }}
    >
      <motion.span
        aria-hidden
        className="absolute top-[3px] h-[28px] w-[28px] rounded-full"
        style={{ background: 'var(--fg)' }}
        animate={{ left: isDark ? 38 : 3 }}
        transition={{ type: 'spring', stiffness: 400, damping: 30, mass: 0.6 }}
      />
      <span className="relative z-10 flex-1 flex items-center justify-center h-full">
        <Sun size={14} strokeWidth={1.6} style={{ color: !isDark ? 'var(--bg)' : 'var(--fg)', opacity: !isDark ? 1 : 0.55 }} />
      </span>
      <span className="relative z-10 flex-1 flex items-center justify-center h-full">
        <Moon size={13} strokeWidth={1.6} style={{ color: isDark ? 'var(--bg)' : 'var(--fg)', opacity: isDark ? 1 : 0.55 }} />
      </span>
    </button>
  );
}
